/**
 * Opt-in traces for geocoding → city/country → search payload.
 * Enable: localStorage.setItem('GEOCODING_MAP_DEBUG', '1')
 * Or Vite: VITE_GEOCODING_MAP_DEBUG=1
 */
function envFlag() {
  try {
    if (typeof import.meta !== "undefined" && import.meta.env?.VITE_GEOCODING_MAP_DEBUG === "1") {
      return true;
    }
  } catch (_) {
    /* ignore */
  }
  return false;
}

export function isGeocodingMapDebugEnabled() {
  try {
    if (typeof window !== "undefined" && window.localStorage?.getItem("GEOCODING_MAP_DEBUG") === "1") {
      return true;
    }
  } catch (_) {
    /* ignore */
  }
  return envFlag();
}

export function logGeocodingMap(stage, payload) {
  if (!isGeocodingMapDebugEnabled()) return;
  try {
    console.log("[GEOCODING_MAP]", stage, payload);
  } catch (_) {
    /* ignore */
  }
}
